/** Admin-owned presentation metadata only. Never product identity or pricing. */
export const PRODUCT_DISPLAY_SURFACES=Object.freeze(['pos','customer','keeta','foodpanda','production'] as const);
export type ProductDisplaySurface=typeof PRODUCT_DISPLAY_SURFACES[number];
export type ProductDisplayNames=Readonly<Partial<Record<ProductDisplaySurface,string>>>;
export function normalizeProductDisplayNames(value:unknown):ProductDisplayNames|undefined{
  if(!value||typeof value!=='object'||Array.isArray(value))return undefined;
  const source=value as Record<string,unknown>,result:Partial<Record<ProductDisplaySurface,string>>={};
  for(const surface of PRODUCT_DISPLAY_SURFACES){const name=typeof source[surface]==='string'?source[surface].trim().slice(0,80):'';if(name)result[surface]=name;}
  return Object.keys(result).length?Object.freeze(result):undefined;
}
export function productDisplayName(product:Readonly<{name:string;displayNames?:ProductDisplayNames}>,surface:ProductDisplaySurface):string{
  return compactRiceballMealName(normalizeProductDisplayNames(product.displayNames)?.[surface]||product.name);
}
export function compactRiceballMealName(name:string):string{
  const text=name.normalize('NFKC');
  const tier=text.trim().match(/^([ABCD])\s*餐\s*[・·‧．-]?\s*自選紫米套餐$/i)?.[1];
  return tier?'紫米'+tier.toUpperCase()+'餐':name;
}

/** Frontline copy only; canonical names remain on selections and receipts. */
export function frontlineOptionName(option:Readonly<{name:string;shortName?:string}>):string{return option.shortName?.trim()||option.name;}
